<script lang="ts">
    import { getClient } from "../utils.js";
    import Pdf from "./common/pdf.svelte";
    import * as Accordion from "./ui/accordion/index.js";
    import type { InboxId, AttachmentId } from "@repo/backend/types";
    import { firstOrDie, isPDF } from "@repo/utils";
    import Download from "@lucide/svelte/icons/download";
    import { Button } from "./ui/button/index.js";

    const {
        attachmentId,
        contentType,
        filename,
        inboxId,
        data,
    }: {
        attachmentId: AttachmentId;
        contentType: string;
        filename: string;
        inboxId: InboxId;
        data?: string;
    } = $props();

    const promise = $derived(
        data ??
            getClient()
                ["Select attachments base64 content"]({
                    jsonBody: [{ attachmentId: attachmentId, inboxId: inboxId }],
                })
                .then(x => firstOrDie(x).data),
    );
</script>

<Accordion.Item value={attachmentId}>
    <Accordion.Trigger class="flex items-center justify-between">
        <span>{filename}</span>
    </Accordion.Trigger>
    <Accordion.Content>
        {#await promise}
            <div class="text-muted-foreground">Loading...</div>
        {:then content}
            <div class="mb-2">
                <Button variant="outline" size="sm" href={`data:${contentType};base64,${content}`} download={filename}>
                    <Download class="mr-2 h-4 w-4" />
                    Download
                </Button>
            </div>
            {#if isPDF({ contentType, filename })}
                <Pdf {content} />
            {:else if contentType === "image/jpeg"}
                <img src={`data:image/jpeg;base64,${content}`} alt={filename} />
            {:else if contentType === "image/png"}
                <img src={`data:image/png;base64,${content}`} alt={filename} />
            {:else}
                <div class="text-error-foreground">
                    Unsupported attachment format {filename}
                    {contentType}
                </div>
            {/if}
        {:catch}
            <div class="text-error-foreground">An error occurred while fetching</div>
        {/await}
    </Accordion.Content>
</Accordion.Item>
